// @flow
import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'
import { Link } from 'gatsby'
import * as React from 'react'

import { colors, media } from '@toggl/style'
import { Button, SectionCascade, text } from '@toggl/ui'
import SignupForm from 'components/SignupForm'

type Props = {|
  +className?: string,
  light?: boolean,
  titleLeft?: string,
  titleRight?: string,
  subtitleRight?: string,
  subtitleSecondaryRight?: string,
  buttonTextRight?: string,
  demoSource: string,
|}

export default function Signup({
  className,
  light,
  titleLeft,
  titleRight,
  subtitleRight,
  subtitleSecondaryRight,
  buttonTextRight,
  demoSource,
}: Props) {
  const theme = useTheme()
  const themeVersion = !light ? 'dark' : 'light'
  const themeVersionInverse = light ? 'dark' : 'light'

  return (
    <SectionCascade.Wrapper className={className}>
      <SectionCascade.Left
        background={theme[themeVersion].background}
        header={
          <text.H2 color={theme[themeVersion].text}>
            {titleLeft || 'Sign up for free'}
          </text.H2>
        }
      >
        <SignupForm
          textColor={theme[themeVersion].text}
          expandable
          planId={0}
          SubmitButton={light ? Button.Alternate : Button.Primary}
        />
      </SectionCascade.Left>

      <SectionCascade.Right
        background={theme[themeVersionInverse].background}
        header={
          <text.H3 color={theme[themeVersionInverse].text}>
            {titleRight || 'Prefer a product demo instead?'}
          </text.H3>
        }
      >
        <React.Fragment>
          <text.P2 color={theme[themeVersionInverse].text}>
            {subtitleRight ||
              'Teams of 10+ are eligible for a personalized demo to see how Toggl Track can meet your time tracking goals'}
          </text.P2>
          {subtitleSecondaryRight ? (
            <React.Fragment>
              <SeparatorLine />
              <text.P2 color={theme[themeVersionInverse].text}>
                {subtitleSecondaryRight ||
                  'Teams of 15+ are eligible for a personalized demo to see how Toggl Track can meet your time tracking goals'}
              </text.P2>
            </React.Fragment>
          ) : (
            ''
          )}
          <TrySectionFooter>
            <Link to={`/track/demo-request/?source='${demoSource}`}>
              <Button.Primary tabIndex="-1">
                {buttonTextRight || 'Book a demo'}
              </Button.Primary>
            </Link>
          </TrySectionFooter>
        </React.Fragment>
      </SectionCascade.Right>
    </SectionCascade.Wrapper>
  )
}

const SeparatorLine = styled.div`
  height: 1px;
  background-color: ${colors.pink};

  ${media.mq[0]} {
    width: calc(100% - 60px);
    margin: 26px auto;
  }

  ${media.mq[2]} {
    width: 260px;
    margin: 26px 0;
  }
`

export const TrySectionFooter: React.ComponentType<any> = styled.div`
  button {
    margin-top: 30px;
  }
`
